<template>
  <div >
    <lottie-player
      ref="player"
      :src="src"
      background="transparent"
      speed="1"
      style="width: 82px; height: 44px"
      autoplay
    ></lottie-player>
  </div>
</template>

<script>
export default {
  name: "LottieIcon",
  props: {
    src: String,
  },
  // mounted() {
  //   setTimeout(() => {
  //     this.$refs.player.stop();
  //     this.$refs.player.seek("100%");
  //   }, 1000)
  // },
};
</script>
